import Vue from "vue";
import Vuex from "vuex";
import http from "../../service/data-service";

function DataURIToBlob(dataURI: string) {
  const splitDataURI = dataURI.split(',')
  const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i)

  return new Blob([ia], { type: mimeString })
}

export default {
  actions: {
    fetchClientes({ commit }: { commit: any }) {
      console.log("asdfa");
      return new Promise((resolve, reject) => {
        http
          .get("/api/v1/profile/" )
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    fetchCarteiraCliente({ commit }: { commit: any }, id: any) {
      return new Promise((resolve, reject) => {
        http
          .get("/api/v1/carteira/getCarteiraCliente/"+id )
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    fetchIndicacoesCliente({ commit }: { commit: any }, id: any) {
      return new Promise((resolve, reject) => {
        http
          .get("/api/v1/indicacao/findIndicacoesById/"+id )
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    updateCliente({ commit }: { commit: any }, payload: any) {
      commit("setLoading", true);
      commit("clearError");
      return new Promise((resolve, reject) => {
        http
          .put("/api/v1/profile/update/"+payload.id, payload)
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
      });
    },
  },
};
